import {useState} from 'react';
import {Redirect} from 'react-router';
import AppBar from '@material-ui/core/AppBar';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircle from '@material-ui/icons/AccountCircle';

import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import {signOut} from 'services/firebase-service';
import Menu from '@material-ui/core/Menu';
// import Copyright from 'packages/common-ui/Copyright';
import useAppAuth from 'packages/hooks/use-app-auth';
import ActiveTournaments from './ActiveTournaments';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: `100vh`,
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  heroContent: {
    flex: 1,
    position: 'relative',
    padding: theme.spacing(8, 8),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  title: {
    flexGrow: 1,
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

const HomePage = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpenAnchor = Boolean(anchorEl);
  const auth = useAppAuth();

  if (auth?.authenticated && auth.isAdmin) return <Redirect to="/admin" />;

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar className={classes.appBar} position="relative" variant="outlined">
        <Toolbar className={classes.toolbar}>
          <Typography
            variant="h6"
            color="inherit"
            className={classes.title}
            noWrap
          >
            Fullcap
          </Typography>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isOpenAnchor}
            onClose={handleCloseMenu}
          >
            <MenuItem disabled value="">
              <em>Fullcap</em>
            </MenuItem>
            <MenuItem onClick={() => signOut()}>Cerrar sesión</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <div className={classes.heroContent}>
        <h1>Lista de torneos activos</h1>
        <ActiveTournaments />
      </div>

      {/* Footer */}
      <footer className={classes.footer}>
        {/* <Typography variant="h6" align="center" gutterBottom>
          Fundacion full dominó colombia
        </Typography>
        <Typography
          variant="caption"
          align="center"
          color="textSecondary"
          component="p"
        >
          Hecho para la fundación Full Dominó Colombia por GG&RA
        </Typography> */}
        {/* <Copyright /> */}
      </footer>
      {/* End footer */}
    </div>
  );
};

export default HomePage;
